// React
import React from "react";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./FlexItem.less";
//-------------------------------------------------------------------------------------------------------------------------------
//-- Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class FlexItem extends React.Component {
    render() {
        let { flexFactor, className } = this.props;
        if (!flexFactor && flexFactor != 0) {
            flexFactor = 1;
        }
        let flexNumber = styles.flexZero;
        switch (flexFactor) {
            case 0:
                flexNumber = styles.flexZero;
                break;
            case 1:
                flexNumber = styles.flexOne;
                break;
            case 2:
                flexNumber = styles.flexTwo;
                break;
            case 3:
                flexNumber = styles.flexThree;
                break;
            case 4:
                flexNumber = styles.flexFour;
                break;
            case 5:
                flexNumber = styles.flexFive;
                break;
            case 6:
                flexNumber = styles.flexSix;
                break;
            case 7:
                flexNumber = styles.flexSeven;
                break;
            case 8:
                flexNumber = styles.flexEight;
                break;
            case 9:
                flexNumber = styles.flexNine;
                break;
            case 10:
                flexNumber = styles.flexTen;
                break;
            case 11:
                flexNumber = styles.flexEleven;
                break;
            case 12:
                flexNumber = styles.flexTwelve;
                break;
            default: flexNumber = styles.flexZero;
        }
        if (!className) {
            className = "";
        }
        return (React.createElement("div", { className: className + " " + flexNumber }, this.props.children));
    }
}
